
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/ifinca",
      function () {
        return require("private-next-pages/case-study/ifinca/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/ifinca"])
      });
    }
  